import { dayjsTz } from "@/app/_utils/dayjs";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ShowMonthNav({
  year,
  month,
  onMonthChange,
}: {
  year: number;
  month: number;
  onMonthChange: (year: number, month: number) => void;
}) {
  const today = dayjsTz();

  const monthLabel = new Date(year, month, 1).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });

  function goToMonth(delta: number) {
    let newMonth = month + delta;
    let newYear = year;
    if (newMonth < 0) {
      newMonth = 11;
      newYear -= 1;
    } else if (newMonth > 11) {
      newMonth = 0;
      newYear += 1;
    }
    onMonthChange(newYear, newMonth);
  }

  function goToToday() {
    onMonthChange(today.year(), today.month());
  }

  return (
    <div className="flex shrink-0 items-center justify-between border-b border-border px-3 py-1.5">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => goToMonth(-1)}
          className="flex size-6 items-center justify-center rounded-md border border-border text-muted-foreground hover:bg-muted"
        >
          <ChevronLeft className="size-4" />
        </button>
        <span className="min-w-[130px] text-center text-sm font-semibold tracking-tight">
          {monthLabel}
        </span>
        <button
          type="button"
          onClick={() => goToMonth(1)}
          className="flex size-6 items-center justify-center rounded-md border border-border text-muted-foreground hover:bg-muted"
        >
          <ChevronRight className="size-4" />
        </button>
      </div>
      <button
        type="button"
        onClick={goToToday}
        className="h-6 rounded-md border border-border px-2.5 text-[12px] font-medium text-muted-foreground hover:bg-muted"
      >
        Today
      </button>
    </div>
  );
}
